import { createSlice } from '@reduxjs/toolkit';
// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading:false,
  roleSelected:{}
};
//
const slice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getRoleSelectedSuccess(state, action) {
      const participants = action.payload;
      state.roleSelected = participants;
    },

  }
});

// Reducer
export default slice.reducer;


export function roleSelected(param) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
        dispatch(slice.actions.getRoleSelectedSuccess(param));
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}
